import { render } from "./PopupUpload.vue?vue&type=template&id=cc9c472c&scoped=true"
import script from "./PopupUpload.vue?vue&type=script&lang=js"
export * from "./PopupUpload.vue?vue&type=script&lang=js"

import "./PopupUpload.vue?vue&type=style&index=0&id=cc9c472c&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc9c472c"]])

export default __exports__